const Visitor_Type = {
  NEW: "new",
  RETURNING: "returning",
};

// Declared in "/assets/custom.js"
// const getCookie = () => {};
// const setCookie = () => {};

function getVisitorType() {
  const name = "firstVisit";
  const returningThreshold = 30 * 60 * 1000; // 30 minutes or more will be considered as returning visitor
  const firstVisit = getCookie(name);
  const now = new Date();
  const timestamp = now.getTime();
  if (firstVisit) {
    const differenceInMilliseconds = Math.abs(
      timestamp - parseInt(firstVisit.trim())
    );
    const differenceInMinutes = Math.floor(
      differenceInMilliseconds / (1000 * 60)
    );

    if (differenceInMinutes > returningThreshold) {
      return Visitor_Type.RETURNING;
    }
  }

  setCookie(name, timestamp, 365);

  return Visitor_Type.NEW;
}

// Add Product Prices Beside ATC Button
function test_1453() {
  const updatePrice = (variantChangeEvent) => {
    if (variantChangeEvent && variantChangeEvent.data.variant) {
      window.currentVariant = variantChangeEvent.data.variant;
    }

    const atc = document.querySelector(".product-form__submit span");
    const quantity = parseInt(
      // document.querySelector("product-info .quantity__input")?.value || "1"
      document.querySelector(
        "product-info .quantity__input:not(.single-upsell__quantity-selector .quantity__input):not(.slider-upsell-quantity-input)"
      )?.value || "1"
    );

    let total = window.currentVariant.price * quantity;

    // #region Calculate addon total
    // PAM
    const pamAddon = document.querySelector(".pam-addons");
    if (pamAddon) {
      const pamAddonCheckbox = document.querySelector(".pam-addons__checkbox");
      if (pamAddonCheckbox && pamAddonCheckbox.checked) {
        total += addon.hh.price;
      }
    }
    // KDT & KDC
    const kinDiningAddon = document.querySelector(
      ".kin-dining-upsell__product"
    );
    if (kinDiningAddon) {
      const selectedKinDiningAddons = document.querySelectorAll(
        ".kin-dining-upsell__checkbox:checked"
      );
      const addonTotal = Array.from(selectedKinDiningAddons).reduce(
        (acc, el) => {
          const price = parseInt(el.dataset.price);
          const quantity =
            el.closest("kin-dining-upsell-product").quantity / 2 || 1;
          return acc + price * quantity;
        },
        0
      );
      total += addonTotal;
    }
    // EVS
    const evsAddon = document.querySelector(".evs-modules-upsell");
    if (evsAddon) {
      const selectedEVSAddons = document.querySelectorAll(
        ".evs-module__checkbox:checked"
      );
      const addonTotal = Array.from(selectedEVSAddons).reduce((acc, el) => {
        const price = parseInt(el.dataset.price);
        const quantity = el.closest("evs-module").quantity || 1;
        return acc + price * quantity;
      }, 0);
      total += addonTotal;
    }
    // #endregion

    atc.dataset.total = window.formatMoney(total);
    atc.classList.add("total");
  };

  const subscribeVariantChange = () => {
    if (subscribe && PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, updatePrice.bind(null));
      return;
    }
    setTimeout(subscribeVariantChange.bind(null), 250);
  };

  const qtyInput = document.querySelector(".quantity__input");
  if (qtyInput) {
    qtyInput.addEventListener("change", updatePrice);
  }

  document
    .querySelectorAll(
      ".pam-addons__checkbox, .kin-dining-upsell__checkbox, .kin-dining-upsell__button, .evs-module__checkbox, .evs-module__button, .quantity__button"
    )
    .forEach((el) => el.addEventListener("click", () => updatePrice()));

  updatePrice();
  subscribeVariantChange();
}

function onDOMContentLoaded() {
  const isHomepage = window.location.pathname === "/";
  const isProductPage = window.location.pathname.includes("/products/");

  const isNewVisitor = getVisitorType() == Visitor_Type.NEW;

  if (isProductPage) {
    test_1453();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
    once: true,
  });
} else {
  onDOMContentLoaded();
}
